export enum EComponentType {
    NOSE = "nose",
    BODY = "body",
    TAIL = "tail",
}
